module.exports = __webpack_public_path__ + "media/pl_pl_s2_Bolek.ca82a0be.oga";